import React, { useState, useEffect } from "react";
import './HomePage.css';
import Row from '../../widgets/Row';
import ChoiseWidget from "../../widgets/ChoiseWidget";
import phot1 from '../../images/them.jpg'
import photo2 from '../../images/cover.jpg'
import photo3 from '../../images/kamati.jpg'
import logo from "../../images/logo.png";
import "tailwindcss";

export default function HomePage() {
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const images = [
        "https://firebasestorage.googleapis.com/v0/b/the-cpct.firebasestorage.app/o/picha%2Fmkutano-mkuu-2025%2FCPCT_318.jpg?alt=media&token=fcd009d6-5991-4d41-af24-4d46f3852261",
        phot1,
        photo2,
    ];

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
        }, 5000); // Change image every 5 seconds
        return () => clearInterval(interval);
    }, []);

    return (
        <div className='mainContainer'>
            <div className="header">
                <div className={'homepage-background-image'} style={{ position: 'absolute', width: '100%', height: '100%', top: 0, left: 0, overflow: 'hidden' }}>
                    {images.map((img, index) => (
                        <div
                            key={index}
                            style={{
                                position: 'absolute',
                                width: '100%',
                                height: '100%',
                                top: 0,
                                left: 0,
                                opacity: index === currentImageIndex ? 1 : 0,
                                transition: 'opacity 1s ease-in-out',
                                zIndex: index === currentImageIndex ? 1 : 0
                            }}
                            className={'zoom-holder'}
                        >
                            <div
                                style={{ backgroundImage: `url(${img})` }}
                                className={'normal-background-image zoom-image'}
                            ></div>
                        </div>
                    ))}
                </div>

                <div className="topText" >
                    <span>Baraza la Makanisa ya Kipentekoste Tanzania <span className={'text-amber-200'}>(CPCT)</span></span>
                </div>

            </div>


            <div className={'mainContent'}>

                {/*  Welcome Section   */}
                <section className="sm:py-12 mt-8 md:mt-0 max-w-5xl mx-auto sm:space-y-8">
                    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                        <div className="bg-white shadow-xl dark:bg-gray-800 rounded-2xl p-6 sm:p-8" data-aos="fade-up">
                            <div className="flex flex-col lg:flex-row items-start gap-6 lg:gap-8">

                                {/* Image and Name Container - Left Side */}
                                <div className="flex flex-col w-full md:w-auto items-center lg:items-start gap-4">
                                    <div className="relative sm:justify-items-center flex overflow-hidden rounded-full shadow-lg group">
                                        <img
                                            alt={'Mwenyekiti'}
                                            className="w-48 h-48 sm:w-56 sm:h-56 lg:w-64 lg:h-64 object-cover group-hover:scale-105 transition-transform duration-500"
                                            src={"https://firebasestorage.googleapis.com/v0/b/the-cpct.firebasestorage.app/o/IMG_9952.webp?alt=media&token=336a7e28-ef65-424b-af34-ecfe235c9ebc"}
                                        />
                                    </div>

                                    {/* Person Name - Below Image */}

                                </div>

                                {/* Text Content - Right Side */}
                                <div className="flex-1">
                                    <p className="text-lg text-gray-700 dark:text-gray-300 leading-relaxed">
                                        "Karibu kwenye tovuti ya Baraza la Maaskofu wa Kipentekoste Tanzania. Tuna uhakika kwamba tovuti yetu itakupa taarifa za kutosha. Utaona na kujifunza zaidi kile kinachotuhusu, kile tunachofanya na kile tunachoamini. Tovuti hii itakujulisha kuhusu, baraza,uanachama, shughuli zetu na kutoa taarifa muhimu ambazo unaweza kuzihitaji. Furahia ziara yako katika tovuti yetu. Karibu sana."
                                    </p>
                                    <hr className="border-t border-gray-300 my-4" />

                                    <div className=" mt-1 lg:text-left">
                                        <p className="text-lg font-semibold text-gray-900 dark:text-white">
                                            Rev. Vernon Fernandez
                                        </p>
                                        <p className="text-gray-600 dark:text-gray-400 text-sm">
                                            Mwenyekiti CPCT Taifa
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>


                {/*  Vision & Mission  */}
                <section className="mx-auto">
                    <div className="container px-4 sm:px-6 lg:px-8 max-w-5xl">
                        <div className="mt-6 space-y-4 md:space-y-0 md:mt-0 md:flex items-stretch gap-6">

                            {/* Maono Box */}
                            <div className="bg-white shadow-xl dark:bg-background-dark p-8 rounded-lg  dark:border-gray-700 flex items-start gap-6" data-aos="fade-up" data-aos-delay="100">
                                <div className="flex-shrink-0 w-12 h-12 bg-blue-100 dark:bg-blue-900 rounded-full flex items-center justify-center">
                                    <svg className="w-6 h-6 text-blue-600 dark:text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                    </svg>
                                </div>
                                <div className="flex-1">
                                    <h3 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">Maono</h3>
                                    <p className="text-lg text-gray-700 dark:text-gray-300 leading-relaxed">
                                        Umoja wa Roho, Imani na Ushirika kati ya wanachama wa CPCT na makundi mengine ya Upentekoste ulimwenguni kote. Waefeso 4:3-5, 13.
                                    </p>
                                </div>
                            </div>

                            {/* Dhima Box */}
                            <div className="bg-white shadow-xl dark:bg-background-dark p-8 rounded-lg  dark:border-gray-700 flex items-start gap-6" data-aos="fade-up" data-aos-delay="200">
                                <div className="flex-shrink-0 w-12 h-12 bg-green-100 dark:bg-green-900 rounded-full flex items-center justify-center">
                                    <svg className="w-6 h-6 text-green-600 dark:text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                                    </svg>
                                </div>
                                <div className="flex-1">
                                    <h3 className="text-3xl font-bold text-gray-900 dark:text-white">Dhima</h3>
                                    <p className="text-lg text-gray-700 dark:text-gray-300 leading-relaxed">
                                        Kujenga na kuendeleza umoja, kuimarisha ushirika, kutetea imani ya Upentekoste na kulinda wanachama wake ili kutimiza Agizo Kuu.
                                    </p>
                                </div>
                            </div>

                        </div>
                    </div>
                </section>

                <br></br>
                <br></br>
            </div>


        </div>
    )
}